import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const suspendDriver = (id, reason) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/driver/suspend/${id}`,
    data: {
      reason,
    },
  });
